<template>
    <div>
        <el-button type="success" size="small" icon="el-icon-plus" @click="addHandler">预约开评标室</el-button>
          
        <my-table :data="tableData" :height="tableHeight" style="margin-top:10px">
            <el-table-column label="标段名称" sortable prop="by3" min-width="120" fixed></el-table-column>
            <el-table-column label="标段编号" prop="bdcodes" min-width="120"></el-table-column>
            <el-table-column label="开评标室" sortable prop="site_name" min-width="60"></el-table-column>
            <el-table-column label="开始时间" prop="starttime" min-width="100"></el-table-column>
            <el-table-column label="结束时间" sortable prop="endtime" min-width="100"></el-table-column>
            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">待提交</my-tag>
                    <my-tag type="info" v-if="scope.row.shbj==='1'">已提交待审核</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">审核通过</my-tag>
                    <my-tag type="danger" v-if="scope.row.shbj==='3'">审核退回，{{scope.row.by1}}</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <my-btn
                        type="edit"
                        v-if="scope.row.shbj=='0'||scope.row.shbj=='3'"
                        @click="editHandler(scope.row.guid)">
                            编辑
                    </my-btn>
                    <my-btn 
                        type="del" 
                        v-if="scope.row.shbj=='0'||scope.row.shbj=='3'"
                        @click="del(scope.row.guid)">
                            删除
                    </my-btn>
                    <my-btn 
                        type="detail" 
                        v-if="scope.row.shbj!='3'&&scope.row.shbj!='0'"
                        @click="detail(scope.row.guid)">
                            详情
                    </my-btn>
                </template>
            </el-table-column>
        </my-table>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {   
        return{
            tableData:[],
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        getList(){
            var that = this
            that.$get(`${this.getGetters('bidUrl')}/bidding/hzbSite/list.json`,{
                zbprocode: that.$route.query.zbprocode,
            },(data, res) => {
               that.tableData = data.list;
            });
        },
        // 编辑
        editHandler(guid) {
             this.goto({
                path:'./form',
                query:{
                    zbprocode:this.$route.query.zbprocode,
                    guid:guid,
                }
            });    
        },
        del(guid){
            var that = this
            that.$post(`${this.getGetters('bidUrl')}/bidding/hzbSite/del.json`,{
                zbprocode: that.$route.query.zbprocode,
                guid:guid,
            },(data, res) => {
               that.getList();
            });
        },
        // 详情
        detail(guid){
            this.goto({
                path:'./detail',
                query:{
                    zbprocode:this.$route.query.zbprocode,
                    guid:guid,
                }
            });    
        }
    },
    created() {
        
    },
    mounted() {
        this.getList()
    }
}
</script>

<style scoped lang="scss">

</style>